"use client"; 
import React, { useEffect } from 'react';
import './paymob.css';

const PaymobComponent = ({ paymentData, publicKey }) => {
  const gatewayData = paymentData.gatewayData;
  const clientSecret = gatewayData.clientSecret;

  useEffect(() => {
    // 1️⃣ Inject CSS synchronously and keep refs
    const cssFiles = ['styles.css', 'main.css'];
    const injectedLinks = cssFiles.map(file => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = `https://cdn.jsdelivr.net/npm/paymob-pixel@latest/${file}`;
      document.head.appendChild(link);
      return link;
    });

    let scriptElement = null;
    let isMounted = true;

    // 2️⃣ Load script + initialize Pixel
    const loadAndInit = async () => {
      try {
        // load JS module
        await new Promise((resolve, reject) => {
          scriptElement = document.createElement('script');
          scriptElement.src = 'https://cdn.jsdelivr.net/npm/paymob-pixel@latest/main.js';
          scriptElement.type = 'module';
          scriptElement.onload = resolve;
          scriptElement.onerror = () => reject(new Error('Failed to load Paymob Pixel script'));
          document.body.appendChild(scriptElement);
        });

        if (!isMounted) return;

        // initialize Pixel
        new Pixel({
          publicKey,
          clientSecret,
          paymentMethods: ['card', 'google-pay', 'apple-pay'],
          elementId: 'paymob-elements',
          disablePay: false,
          showSaveCard: true,
          forceSaveCard: true,
          beforePaymentComplete: async (paymentMethod) => {
            console.log(paymentMethod, 'Before payment start');
            await new Promise(res => setTimeout(res, 5000));
            console.log('Before payment end');
            return true;
          },
          afterPaymentComplete: async (response) => {
            console.log('After payment', response);
          },
          onPaymentCancel: () => {
            console.log('Payment has been canceled');
          },
          cardValidationChanged: (isValid) => {
            console.log('Is valid ?', isValid);
          },
          customStyle: {
            Font_Family: 'Gotham',
            Font_Size_Label: '16',
            Font_Size_Input_Fields: '16',
            Font_Size_Payment_Button: '14',
            Font_Weight_Label: 400,
            Font_Weight_Input_Fields: 200,
            Font_Weight_Payment_Button: 600,
            Color_Container: '#FFF',
            Color_Border_Input_Fields: '#D0D5DD',
            Color_Border_Payment_Button: '#A1B8FF',
            Radius_Border: '8',
            Color_Disabled: '#A1B8FF',
            Color_Error: '#CC1142',
            Color_Primary: '#144DFF',
            Color_Input_Fields: '#FFF',
            Text_Color_For_Label: '#000',
            Text_Color_For_Payment_Button: '#FFF',
            Text_Color_For_Input_Fields: '#000',
            Color_For_Text_Placeholder: '#667085',
            Width_of_Container: '100%',
            Vertical_Padding: '40',
            Horizontal_Padding: '20',
            Vertical_Spacing_between_components: '18',
            Container_Padding: '0'
          }
        });
      } catch (error) {
        console.error('Error loading Paymob Pixel:', error);
      }
    };

    loadAndInit();

    // 3️⃣ Cleanup on unmount
    return () => {
      isMounted = false;
      injectedLinks.forEach(link => document.head.removeChild(link));
      if (scriptElement) {
        document.body.removeChild(scriptElement);
      }
    };
  }, [publicKey, clientSecret]);

  return (
    <div>
      <div
        className="wrapper"
        style={{
          margin: '0 1rem',
          backgroundColor: '#fff',
          padding: '1rem',
          borderRadius: '0.5rem'
        }}
      >
        <div
          className="content"
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '2rem'
          }}
        >
          <div id="paymob-elements" style={{ width: '100%' }}></div>
        </div>
      </div>
      <div className="footer"></div>
    </div>
  );
};

export default PaymobComponent;
